import AdminNavigationLayout from 'shared/Layouts/TopNavigationLayout/AdminNavifationLayout'
import TopNavigationLayoutPageContent from 'shared/Layouts/TopNavigationLayout/TopNavigationLayoutPageContent'
import Button from 'shared/Buttons/Button/Button'
import useHttpLoader from 'shared/hooks/useHttpLoader'
import { useSetRecoilState } from 'recoil'
import { useNavigate } from 'react-router-dom'
import checkpointsTableAtom from '../../components/CheckpointsTable/checkpointsTable.atom'
import useStateWithChange from 'shared/hooks/useStateWithChange'
import projectCheckpointsApi from '../../projectCheckpoints.api'
import CheckpointSheet from '../../components/CheckpointSheet'

const CreateCheckpointPage = () => {
  const navigate = useNavigate()
  const { wait, loading } = useHttpLoader()
  const [draft, _setState, handleChange] = useStateWithChange({ name: '', duration: 1 })
  const setState = useSetRecoilState(checkpointsTableAtom)

  const handleCreate = () => {
    wait(projectCheckpointsApi.create({ ...draft, duration: draft.duration * 86400 }), (resp) => {
      if (resp.status === 'success') {
        setState((prev) => ({ ...prev, items: [resp.body, ...prev.items] }))
        navigate(`/admin/project-checkpoints/${resp.body.id}`, { replace: true })
      }
    })
  }

  return (
    <AdminNavigationLayout>
      <TopNavigationLayoutPageContent type='defaultWithBackButton'>
        <div className='flex-space-between' style={{ marginBottom: '10px' }}>
          <div className='inline-flex-gap' style={{ gap: '2.5em' }}>
            <h2 className='page--header'>Создание контрольной точки</h2>
          </div>
        </div>
        <CheckpointSheet checkpoint={draft} onChange={handleChange}>
          <Button
            theme='primary'
            loading={loading}
            onClick={handleCreate}
            style={{ width: 'fit-content', marginTop: '10px' }}
          >
            Создать
          </Button>
        </CheckpointSheet>
      </TopNavigationLayoutPageContent>
    </AdminNavigationLayout>
  )
}

export default CreateCheckpointPage
